import { Dimensions } from 'react-native'
import { getActualImageDimensions } from '../lib/images'
import api from '../services/api'
import { RESET } from '../redux/game'
import theme from '../styles/theme'

// Actions
const FETCHING_DEALS_START = 'ascension/deals/fetching'
const FETCHING_DEALS_SUCCESS = 'ascension/deals/success'
const FETCHING_DEALS_ERROR = 'ascension/deals/error'

const SUBMITTING_DEALS_START = 'ascension/deals/submitting'
const SUBMITTING_DEALS_SUCCESS = 'ascension/deals/submitted'
const SUBMITTING_DEALS_ERROR = 'ascension/deals/submitting_error'

const SET_IMAGE_DIMENSIONS = 'ascension/deals/set_image_dimensions'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  isSubmitting: false,
  bid: 0,
  bidType: 1,
  imageDimensions: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_DEALS_START: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        bid: 0,
        bidType: 1,
        error: null,
        imageDimensions: null
      }
    }
    case FETCHING_DEALS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        bid: action.data.bid,
        bidType: action.data.bidType
      }
    }
    case FETCHING_DEALS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case SUBMITTING_DEALS_START: {
      return {
        ...state,
        isSubmitting: true,
        error: null
      }
    }
    case SUBMITTING_DEALS_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        error: null,
        bid: action.data.bid
      }
    }
    case SUBMITTING_DEALS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case SET_IMAGE_DIMENSIONS: {
      return {
        ...state,
        imageDimensions: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingDealsStart () {
  return {
    type: FETCHING_DEALS_START
  }
}

export function fetchingDealsSuccess ({ bid, bidType }) {
  return {
    type: FETCHING_DEALS_SUCCESS,
    data: { bid, bidType }
  }
}

export function fetchingDealsError (error) {
  return {
    type: FETCHING_DEALS_ERROR,
    data: error
  }
}

export function submittingDealsStart () {
  return {
    type: SUBMITTING_DEALS_START
  }
}

export function submittingDealsSuccess (bid) {
  return {
    type: SUBMITTING_DEALS_SUCCESS,
    data: { bid }
  }
}

export function submittingDealsError (error) {
  return {
    type: SUBMITTING_DEALS_ERROR,
    data: error
  }
}

export function setImageDimensions (dimensions) {
  return {
    type: SET_IMAGE_DIMENSIONS,
    data: dimensions
  }
}

// Action Creators
export function fetchBid (team, round) {
  return async (dispatch) => {
    dispatch(fetchingDealsStart())

    try {
      const response = await api.getDeal(team, round)
      dispatch(fetchingDealsSuccess(response))
    } catch (e) {
      dispatch(fetchingDealsError(e))
    }
  }
}

export function submitBid (team, round, bid) {
  return async (dispatch) => {
    dispatch(submittingDealsStart())

    try {
      await api.bidOnDeal(team, round, bid)
      dispatch(submittingDealsSuccess(bid))
    } catch (e) {
      dispatch(submittingDealsError(e))
    }
  }
}

export function getImageDimensions (url, sidebarWidth) {
  return async (dispatch) => {
    const containerWidth = Dimensions.get('window').width - sidebarWidth
    const containerHeight = Dimensions.get('window').height - theme.headerHeight - theme.teamBarHeight
    const { width, height } = await getActualImageDimensions({ containerWidth, containerHeight, imageUrl: url })
    dispatch(setImageDimensions({ width, height }))
  }
}
